var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('products',{attrs:{"productData":_vm.productData}})}
var staticRenderFns = []

export { render, staticRenderFns }